import { gql } from '@apollo/client';

export const UpdateExcludedValues = gql`
  mutation updateExcludedValues($siteId: String!, $exclusionType: String!, $excludedValues: [String]!) {
    updateExcludedValues(siteId: $siteId, exclusionType: $exclusionType, excludedValues: $excludedValues) {
      _id
      siteId
      siteName
      exclusionType
      excludedValues
    }
  }
`;

export const UpdateAnalyticsExclusion = gql`
  mutation UpdateAnalyticsExclusion($inventoryIds: [String]!, $transactionCycleIds: [String]!, $action: String!) {
    UpdateAnalyticsExclusion(inventoryIds: $inventoryIds, transactionCycleIds: $transactionCycleIds, action: $action) {
      action
      inventoryIds
      transactionCycleIds
    }
  }
`;
